import { useMutation } from 'react-query';
import { loginVendor, socialLogin, verifyOTP } from '../../../store/apiCalls/authentication';

function OnLogin(sucessHandler, error, setError) {
    return {
        ...useMutation(loginVendor, {
            onSuccess: (data) => {
                sucessHandler(data)
                setError({ ...error, apiError: '' })
            },
            onError: (errMsg) => {
                setError({ ...error, apiError: errMsg.response.data.message || 'Something went wrong, Please try again after sometime' })
            },
        })
    }
}
function OnOTPVerification(sucessHandler,setError) {
    return {
        ...useMutation(verifyOTP, {
            onSuccess: (data) => {
                sucessHandler(data)
                setError('')
            },
            onError: (errMsg) => {
                setError(errMsg.response.data.message || 'Something went wrong, Please try again after sometime')

            },
        })
    }
}
function OnSocialLogin(sucessHandler) {
    return {
        ...useMutation(socialLogin, {
            onSuccess: (data) => { sucessHandler(data) },
            onError: (errMsg) => {
                genericError(errMsg.response.data);
            },
        })
    }
}


export {
    OnLogin,
    OnSocialLogin,
    OnOTPVerification,
}
